export default "__VITE_ASSET__31aac3a9__"